/** Request com os dados para reabrir uma das Análises de Mercado */
export class ClienteAnaliseMercadoRevisaoReabrirRequest {
    ano: number;
    idRepresentante: number;

    constructor(ano: number, idRepresentante: number) {
        this.ano = ano;
        this.idRepresentante = idRepresentante;
    }
}
